const METRIC_TONES = new Set(["neutral", "success", "warning", "danger"]);

export default function HeaderMetricGroup({
  items = [],
  busy = false,
  className = "",
  ariaLabel = "요약 정보",
}) {
  return (
    <dl
      className={`ds-header-metrics${className ? ` ${className}` : ""}`}
      aria-label={ariaLabel}
      aria-busy={busy || undefined}
    >
      {items.map((item) => {
        const tone = METRIC_TONES.has(item.tone) ? item.tone : "neutral";

        return (
          <div
            key={item.key ?? item.label}
            className={`ds-header-metric ds-header-metric--${tone}`}
          >
            <dt className="ds-header-metric__label">{item.label}</dt>
            <dd className="ds-header-metric__value">{item.value}</dd>
          </div>
        );
      })}
    </dl>
  );
}
